module.exports = __webpack_public_path__ + "static/logoyash-ef82305d41ce10ff4f19362285ba41fa.png";